import { render, staticRenderFns } from "./document-row.vue?vue&type=template&id=6603d800&scoped=true"
import script from "./document-row.vue?vue&type=script&lang=js"
export * from "./document-row.vue?vue&type=script&lang=js"
import style0 from "./document-row.vue?vue&type=style&index=0&id=6603d800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6603d800",
  null
  
)

export default component.exports